import React, {useContext} from 'react';
import {TrackingContext, TrackingContextAppend} from './TrackingContext.jsx';
import classNames from 'classnames';
import {Link} from './Link.jsx';
import {BenefitTag, Icon, Typography} from '@bonprix/design-system';
import {articleOverviewStaticContext} from '@article-overview/components/ArticleOverviewStatic.jsx';
import WishlistHeart from '@core/scripts/components/wishlist/heart';
import {useTranslations} from './Text.jsx';
import {XRay} from '@teaser/scripts/components/XRay.jsx';

export function ProductSummary({product, className, showProductInfo = true, wishListHeartClass}) {
    const wishlistEnabled = useContext(articleOverviewStaticContext);
    const parentContext = useContext(TrackingContext);
    const t = useTranslations();

    return (
        <TrackingContextAppend
            value={{
                id: product.entryId,
                teaserId: parentContext.id,
            }}
        >
            <div className={classNames(className)}>
                <XRay fieldId="product" entryId={product.entryId} contentType={product.contentType} />
                <Link
                    model={product}
                    className="content-platform__product-slider__slider__slide__container"
                    hash={product.soldOut ? 'product-recommendations' : null}
                >
                    <div
                        className={classNames(
                            'content-platform__product-slider__slider__slide__image',
                            product.soldOut && '-sold-out',
                        )}
                    >
                        <img
                            alt={product.productName}
                            src={`//image01.bonprix.de/assets/158x217/${product.imagePath}`}
                            srcSet={`
                                        //image01.bonprix.de/assets/158x217/${product.imagePath} 158w,
                                        //image01.bonprix.de/assets/192x264/${product.imagePath} 192w,
                                        //image01.bonprix.de/assets/301x413/${product.imagePath} 301w
                                      `}
                            sizes="(max-width: 480px) 33vw, (max-width: 768px) 25vw, 20vw"
                        />
                        {product.soldOut && (
                            <span className="content-platform__product-slider__slider__slide__sold-out">
                                {t('aa_ausverkauft')}
                                <div className="aop-alternative">
                                    <Typography component="u">{t('ada_shop_the_look_alternative_product')}</Typography>
                                    <Icon variant="arrow-right" className="h-4 w-4" />
                                </div>
                            </span>
                        )}
                    </div>

                    {showProductInfo && (
                        <div className="content-platform__product-slider__slider__slide__info">
                            {product.benefits.map((benefit) => (
                                <BenefitTag key={benefit.name} variant={benefit.displayType.toLowerCase()} size="small">
                                    {benefit.name}
                                </BenefitTag>
                            ))}

                            <span className="content-platform__product-slider__slider__slide__info__name">
                                {product.productName}
                            </span>

                            {product.price && (
                                <span
                                    className={classNames(
                                        'content-platform__product-slider__slider__slide__info__price',
                                        product.price.formerPriceWholeNumber && '-reduced',
                                    )}
                                >
                                    {product.price.uniquePrice ? '' : t('au_ab')} {product.price.formattedPrice}
                                </span>
                            )}

                            {product.price && product.price.formerPriceWholeNumber && (
                                <div className="content-platform__product-slider__slider__slide__info__reduced">
                                    <span
                                        className={
                                            'content-platform__product-slider__slider__slide__info__reduced__price'
                                        }
                                    >
                                        {product.price.formattedFormerPrice}
                                    </span>
                                    {product.price.priceReduction && (
                                        <span className="content-platform__product-slider__slider__slide__info__reduced__reduction">
                                            -{product.price.priceReduction}%
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </Link>
                {wishlistEnabled && !product.soldOut && (
                    <WishlistHeart
                        className={`content-platform__add-to-wishlist-heart ${wishListHeartClass}`}
                        articleNumber={product.articleNumber}
                        promotion={product.promotion}
                        shopId={product.shopId}
                        digistyleId={product.digistyleId}
                        itemId={product.itemId}
                        origin={'Contentful Inspiration AOP'}
                        articlePrice={product.formattedPrice}
                    />
                )}
            </div>
        </TrackingContextAppend>
    );
}
